import * as React from "react";
import {Tooltip} from "@mui/material";
import {MessageDescriptor, useIntl} from "react-intl";

type Props = {
    tooltipTitle: MessageDescriptor; // ID to look up in translation file
    children: React.ReactElement<any, any>;
};

// Custom tooltip for table actions
const TableTooltip = ({tooltipTitle, children}: Props) => {
    const intl = useIntl();

    return (
        <Tooltip title={<h3 style={{fontSize: "0.8rem"}}>{intl.formatMessage(tooltipTitle)}</h3>}>{children}</Tooltip>
    );
};

export default TableTooltip;
